module.exports = __webpack_public_path__ + "h5/img/zijinback.4a93800e.jpg";